export default class PasswordPolicy {
    constructor (json) {
        this.maximumAge = 90;
        this.minimumLength = 8;
        this.alphabeticalCharacters = {
            required: false,
            number: 0,
            uppercaseCharacters: {
                required: false,
                number: 0
            },
            lowercaseCharacters: {
                required: false,
                number: 0
            }
        };
        this.numericCharacters = {
            required: false,
            number: 0
        };
        this.punctuationOrOtherCharacters = {
            required: false,
            number: 0
        };

        if (json)
            mapJsonToPolicy(json, this);
    }

    toJson () {
        var json = {};
        mapSettingsToJson(this, json);
        return json;
    }


    createCopy () {
        const policy = new PasswordPolicy();
        policy.maximumAge = this.maximumAge;
        policy.minimumLength = this.minimumLength;
        policy.alphabeticalCharacters = Object.assign({}, this.alphabeticalCharacters);
        policy.numericCharacters = Object.assign({}, this.numericCharacters);
        policy.punctuationOrOtherCharacters = Object.assign({}, this.punctuationOrOtherCharacters);
        return policy;
    }
}

const mapJsonToPolicy = (json, policy) => {
    policy.maximumAge = json.PasswordValidDays;
    policy.minimumLength = json.MinimumPasswordLength;
    policy.alphabeticalCharacters = {
        required: json.RequiredAlphabeticalLetters + json.RequiredCapitalLetters + json.RequiredLowercaseLetters > 0,
        number: json.RequiredAlphabeticalLetters,
        uppercaseCharacters: {
            required: json.RequiredCapitalLetters > 0,
            number: json.RequiredCapitalLetters
        },
        lowercaseCharacters: {
            required: json.RequiredLowercaseLetters > 0,
            number: json.RequiredLowercaseLetters
        }
    };
    policy.numericCharacters = {
        required: json.RequiredNumerals > 0,
        number: json.RequiredNumerals
    };
    policy.punctuationOrOtherCharacters = {
        required: json.RequiredPunctuationOrOther > 0,
        number: json.RequiredPunctuationOrOther
    };
};
